/*------------------------------------*\
    TABS MODULE
\*------------------------------------*/
class Tabs {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;
        self.fade();
    }

    fade() {
        let self = this;

        window.addEventListener("load", function () {
            let tabItems = self.elem.querySelectorAll('.tabs__list-item');
            let tabs = self.elem.querySelectorAll('[data-tab-item]');
            let tabsContent = self.elem.querySelectorAll('[data-tab-content]');

            tabs.forEach(function (item) {
                item.addEventListener('click', function() {
                    tabItems.forEach(function (tab) {
                        tab.classList.remove('tabs__list-item--active');
                    });

                    tabsContent.forEach(function (content) {
                        content.classList.remove('tabs__tab--active');

                        if (content.id == item.getAttribute('data-tab-item-btn')) {
                            content.classList.add('tabs__tab--active');
                        }
                    });

                    item.classList.add('tabs__list-item--active');
                });
            });
        });
    }
}

export default Tabs;
